export * from './InternetService.container'



// WEBPACK FOOTER //
// src/pages/InternetService/index.ts